import React, { useEffect, useState } from "react";
import '../../Styles/tools/DataToolSearch.css';
import { Accordion, Card } from "react-bootstrap";
import { getAdvanceSearch, getSimpleSearch } from "../../API/annotatorApi";
import { getOut } from "../../Utils/Common";
import SearchJobsComponent from "./SearchJobsComponent";
import { getIndustries } from '../../API/industry';
import { getKategoriesDataAPI } from '../../API/kategories';

function DataToolSearchComponent() {
    const [categories, setCategories] = useState([]);
    const [industries, setIndustries] = useState([]);
    const [isCompletedOnly, setIsCompletedOnly] = useState(true);
    const [isExcludeCat, setIsExcludeCat] = useState(false);

    useEffect(async () => {
        let categories = await getKategoriesDataAPI();
        setCategories(categories.map(o => o.category).sort());

        const fetchIndustries = async () => {
            try {
                const industriesResponse = await getIndustries();
                setIndustries(industriesResponse);
            } catch (error) {
                console.error("Error fetching industries:", error);
            }
        };

        fetchIndustries();
    }, []);

    const positions = async () => {
        let response;
        let query = document.getElementById('query').value.trim();
        let start = document.getElementById('start').value;
        let end = document.getElementById('end').value;
        let category = document.getElementById('category').value;
        let industry = document.getElementById('industry').value;
        let cat_exclude = document.getElementById('cat_exclude').checked;
        let hinweis_only = document.getElementById('hinweis_only').checked;
        let completed_only = document.getElementById('completed_only').checked;

        if (query === '' && category === '') {
            alert("Both search term and category cannot be empty");
            return;
        }

        if (query === '' && cat_exclude) {
            alert("This search may return too many results. Please either specify a search term or a category to search in or both.");
            return;
        }

        if (start === '' || end === '') {
            category = category === "" ? null : category;
            industry = industry === "" ? null : industry;

            response = await getSimpleSearch(query, category, industry, cat_exclude, hinweis_only, completed_only);
            if (response.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
                getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
            }
        } else {
            response = await getAdvanceSearch(query, start, end, category, industry, cat_exclude, hinweis_only, completed_only);
            if (response.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
                getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
            }
        }
    };

    const handleCompletedChange = () => {
        setIsCompletedOnly(!isCompletedOnly)
    }

    const handleExcludeCatChange = () => {
        setIsExcludeCat(!isExcludeCat)
    }

    return (
        <div className="container mt-5">
            <div className="row d-flex justify-content-center">
                <div className="col-md-10">
                    <div className="card p-3 py-4">
                        <h5>Search Tool</h5>
                        <div className="row g-3 mt-2">
                            <div className="col-md-12" style={{paddingBottom: "5px", display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <input type="text" id="query" className="form-control" placeholder="Enter a Keyword or Phrase" />
                                <label style={{whiteSpace: 'nowrap'}}>
                                    &nbsp;&nbsp;&nbsp;&nbsp;Headlines only&nbsp;&nbsp;
                                    <input type="checkbox" id="hinweis_only" style={{verticalAlign: 'middle', transform: "scale(1.5)"}}/>
                                </label>
                            </div>
                            <div className="col-md-12" style={{
                                paddingBottom: '5px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <label style={{ whiteSpace: 'nowrap' }}>
                                    Not in&nbsp;&nbsp;
                                    <input type="checkbox"
                                           id="cat_exclude"
                                           checked={isExcludeCat}
                                           onChange={handleExcludeCatChange}
                                           style={{ verticalAlign: 'middle', transform: 'scale(1.5)' }} />
                                </label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <select id="category" className="form-control">
                                    <option value="">Select Category</option>
                                    {categories.map((category, index) => (
                                        <option key={index} value={category}>{category}</option>
                                    ))}
                                </select>
                                <label style={{ whiteSpace: 'nowrap' }}>
                                    &nbsp;&nbsp;&nbsp;&nbsp;Completed only&nbsp;&nbsp;
                                    <input type="checkbox"
                                           id="completed_only"
                                           checked={isCompletedOnly}
                                           onChange={handleCompletedChange}
                                           style={{ verticalAlign: 'middle', transform: 'scale(1.5)' }} />
                                </label>
                            </div>
                            <div className="col-md-12">
                                <select id="industry" className="form-control">
                                    <option value="">Select Industry</option>
                                    {industries.map((industry) => (
                                        <option key={industry.industry_id}
                                                value={industry.industry_name}>{industry.industry_name}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="mt-3">
                            <Accordion>
                                <Card>
                                    <Card.Header>
                                        <Accordion.Toggle as={Card.Header} className="btn handwai-btn-logout" eventKey="1">
                                            Advanced Search
                                        </Accordion.Toggle>
                                    </Card.Header>
                                    <Accordion.Collapse eventKey="1">
                                        <Card.Body>
                                            <label className="form-control col-md-12"> Start Date </label>
                                            <input type="date" id="start" placeholder="start date" />
                                            <label className="form-control col-md-12"> End Date </label>
                                            <input type="date" id="end" placeholder="end date" />
                                        </Card.Body>
                                    </Accordion.Collapse>
                                </Card>
                            </Accordion>
                            <div className="col-md-12" style={{paddingTop: "5px"}}>
                                <button className="btn btn-secondary btn-block" onClick={positions}>Search Results</button>
                            </div>
                            <div className="collapse" id="collapseExample">
                                <div className="card card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <input type="text" placeholder="Property ID" className="form-control" />
                                        </div>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" placeholder="Search by MAP" />
                                        </div>
                                        <div className="col-md-4">
                                            <input type="text" className="form-control" placeholder="Search by Country" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <br />
            <div className="mt-5">
                <SearchJobsComponent />
            </div>
        </div>
    );
}

export default DataToolSearchComponent;